// src/components/MenuButton.js
import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./MenuButton.module.css";

function MenuButton({ icon, text, link, image, onClick, HtmlIcon }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick(); // Call the onClick function if provided
        } else {
            navigate(link); // Default navigation
        }
    };

    return (
        <div onClick={handleClick} className={styles.menuButton}>
            <div className="tw-flex tw-gap-2 tw-items-center">
                {image && <img src={image} alt={text} className={styles.icon} />}
                {icon && <span className="tw-text-[24px]">{icon}</span>}
                {HtmlIcon && <div className="tw-text-primary tw-text-[28px] tw-mr-[13px]">{HtmlIcon}</div>}
                <span className={styles.text}>{text}</span>
            </div>
            <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/6c1c3121588014f80a5460e8d9ee2052a42e209486c9ee872b95e988068f882b?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                alt=""
                className={styles.arrowIcon}
            />
        </div>
    );
}

export default MenuButton;
